export const OLD_SHAPES_DEFAULT_AXES = [
    {
        name: 'x',
        type: 'space',
        unit: 'unit',
    },
    {
        name: 'y',
        type: 'space',
        unit: 'unit',
    },
];
export const OLD_SHAPES_DEFAULT_COORDINATE_TRANSFORMATIONS = [
    {
        input: {
            axes: [
                {
                    name: 'x',
                    type: 'space',
                    unit: 'unit',
                },
                {
                    name: 'y',
                    type: 'space',
                    unit: 'unit',
                },
            ],
            name: 'xy',
        },
        output: {
            axes: [
                {
                    name: 'x',
                    type: 'space',
                    unit: 'unit',
                },
                {
                    name: 'y',
                    type: 'space',
                    unit: 'unit',
                },
            ],
            name: 'global',
        },
        type: 'identity',
    },
];
//# sourceMappingURL=old-defaults.js.map